import db from "../db/database";
import { isOnline } from "./syncService";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";

export const syncVendors = async () => {
  if (!isOnline()) {
    return false;
  }

  try {
    const serverVendors = await fetchFromBusinessCentral("Vendedores");

    if (!serverVendors) {
      return false;
    }

    await db.vendedores.clear();

    for (const vendor of serverVendors) {
      await db.vendedores.add({
        value: vendor?.Code ?? "",
        label: vendor?.Name ?? "",
        lastModified: new Date(),
        lastSynced: new Date(),
        pendingSync: 0,
        deleted: false,
      });
    }

    return true;
  } catch (error) {
    console.error("Error al sincronizar vendedores:", error);
    return false;
  }
};

export function mergeVendors(byName = [], byNo = []) {
  const map = new Map();

  byName.forEach((v) => {
    map.set(v.value, v);
  });

  byNo.forEach((v) => {
    map.set(v.value, v);
  });

  return Array.from(map.values());
}

export async function getAllVendors() {
  return await db.vendedores.orderBy("label").toArray();
}

export async function searchVendorsPaged({ search = "", page = 1, pageSize = 10 }) {
  const offset = (page - 1) * pageSize;

  let merged = [];

  if (search && search.trim() !== "") {
    const searchValue = search.toLowerCase();

    // primero intentamos busqueda indexada
    const byName = await db.vendedores.where("label").startsWithIgnoreCase(search).toArray();

    const byNo = await db.vendedores.where("value").startsWithIgnoreCase(search).toArray();

    let map = new Map();
    [...byName, ...byNo].forEach((v) => map.set(v.value, v));

    // si no hay resultados, ampliamos busqueda sin indexar con contains
    if (map.size < 1) {
      const extra = await db.vendedores
        .filter(
          (v) =>
            v.label?.toLowerCase().includes(searchValue) ||
            v.value?.toLowerCase().includes(searchValue)
        )
        .toArray();

      extra.forEach((v) => map.set(v.value, v));
    }

    merged = Array.from(map.values());
  } else {
    merged = await db.vendedores.orderBy("label").toArray();
  }

  const total = merged.length;
  const data = merged.slice(offset, offset + pageSize);

  return { data, total };
}

export const getVendedorByNo = async (no) => {
  return await db.vendedores.where("value").equalsIgnoreCase(no).first();
};
